import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { STORAGE_AUTH_TOKEN } from "constants/variables";
import { getLocalStorageItem } from "utils/localStorage";
import { setHostname } from "utils/hostname";
import url from "url/index";
import { setHeaders } from "utils/credential";
import {
  ReferralListRequest,
  ReferralListResponse,
  ReferralRequest,
  ReferralResponse,
  ReferralWithdrawalRequest,
  ReferralWithdrawalResponse,
} from "../../types/Referral";
import {
  setEnabled,
  setError,
  setLink,
  setSuccess,
  setReferralList,
} from "./slice";

export const referralApi = createApi({
  reducerPath: "referralApi",
  baseQuery: fetchBaseQuery({
    baseUrl: setHostname(),
    prepareHeaders: setHeaders,
  }),
  endpoints: (build) => ({
    referral: build.mutation<ReferralResponse, ReferralRequest>({
      query: (request: ReferralRequest) => ({
        url: url.config.api.referral.root,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getLocalStorageItem(STORAGE_AUTH_TOKEN)}`,
        },
        body: request,
      }),
      async onQueryStarted(
        request: ReferralRequest,
        { dispatch, queryFulfilled },
      ) {
        try {
          const { data } = await queryFulfilled;
          if (data) {
            dispatch(setLink(data));
          }
        } catch (error: any) {
          /* empty */
        }
      },
    }),
    referralList: build.query<ReferralListResponse, ReferralListRequest>({
      query: (params: ReferralListRequest) => ({
        url: url.config.api.referral.referralList,
        headers: {
          Authorization: `Bearer ${getLocalStorageItem(STORAGE_AUTH_TOKEN)}`,
        },
        params,
      }),
      async onQueryStarted(
        request: ReferralListRequest,
        { dispatch, queryFulfilled },
      ) {
        try {
          const { data } = await queryFulfilled;
          if (data) {
            dispatch(setReferralList(data));
          }
        } catch (error: any) {
          /* empty */
        }
      },
    }),
    enabled: build.query<boolean, void>({
      query: () => ({
        url: url.config.api.referral.enabled,
        headers: {
          Authorization: `Bearer ${getLocalStorageItem(STORAGE_AUTH_TOKEN)}`,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setEnabled(data));
        } catch (error: any) {
          /* empty */
        }
      },
    }),

    withdrawal: build.mutation<
      ReferralWithdrawalResponse,
      ReferralWithdrawalRequest
    >({
      query: (request: ReferralWithdrawalRequest) => ({
        url: url.config.api.referral.withdrawal,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getLocalStorageItem(STORAGE_AUTH_TOKEN)}`,
        },
        body: request,
      }),
      async onQueryStarted(
        request: ReferralWithdrawalRequest,
        { dispatch, queryFulfilled },
      ) {
        try {
          // eslint-disable-next-line no-empty-pattern
          const {} = await queryFulfilled;
          dispatch(setSuccess());
        } catch (error: any) {
          dispatch(setError(error));
        }
      },
    }),
  }),
});
